module.exports = __webpack_public_path__ + "static/media/Logo__eMerge.d0825ebb.svg";